import axiosInstance from '../utils/axiosInstance';
import { OffersResponse } from './types';

export const getOffers = async () => {
  const response = await axiosInstance.get<OffersResponse>('/offers');
  return response.data;
};
